module.exports = __webpack_public_path__ + "1f22ca1e2890f053bf57ef12d709e9ca.svg";